import api from "./api";

export const getFunnelOpportunities = (funnelId) => {
    return api.get(`/funnels/${funnelId}/opportunities`);
};

export const getFunnelOpportunity = (id) => {
    return api.get(`/funnel-opportunities/${id}`);
};

export const createFunnelOpportunity = (data) => {
    return api.post("/funnel-opportunities", data);
};

export const updateFunnelOpportunity = (id, data) => {
    console.log("[Funnel] Updating opportunity", id, "with data:", data);
    return api.put(`/funnel-opportunities/${id}`, data);
};

export const deleteFunnelOpportunity = (id) => {
    return api.delete(`/funnel-opportunities/${id}`);
};

export const showOppByContact = (contactId) => {
    return api.get(`/funnel-opportunities/contact/${contactId}`);
};

export const moveOpportunity = (id, toCardId, temperature, notes) => {
    return api.post(`/funnel-opportunities/${id}/move`, { toCardId, temperature, notes });
};
